import { Map as MapboxMap } from 'mapbox-gl';
import { forEach as _forEach } from 'lodash';
import { ImageUrl, MapboxIconOptions } from '../../../types/maps.consts';
import { MapboxImage } from '../mapbox';

type IdsMap = { [key: string]: boolean };

export const updateImages = async (
	imagesItems: { imageUrl: string; options?: MapboxIconOptions }[],
	imagesRenderState: Map<ImageUrl, MapboxImage>,
	map: MapboxMap
): Promise<void[]> => {
	const imagesIds = {};
	const addImagesPromises: Promise<void>[] = [];

	_forEach(imagesItems, imageItem => {
		const image = imageItem.imageUrl;
		const imageOptions = imageItem.options;
		imagesIds[image] = true;

		if (!imagesRenderState.has(image)) {
			const addImagesPromise = addImage(image, imagesRenderState, map, imageOptions);
			addImagesPromises.push(addImagesPromise);
		}
	});

	removeOldImages(imagesIds, imagesRenderState, map);

	return Promise.all(addImagesPromises);
};

const addImage = (
	image: ImageUrl,
	imagesRenderState: Map<ImageUrl, MapboxImage>,
	map: MapboxMap,
	imageOptions?: MapboxIconOptions
): Promise<void> => {
	return new Promise<void>((resolve, reject) => {
		map.loadImage(image, (error, imageObject) => {
			if (error) {
				reject();
			}

			const mapboxImage = `image-${image}`;
			if (!map.hasImage(mapboxImage)) {
				map.addImage(mapboxImage, imageObject, imageOptions);
				imagesRenderState.set(image, mapboxImage);
			}
			resolve();
		});
	});
};

const removeImage = (image: ImageUrl, imagesRenderState: Map<ImageUrl, MapboxImage>, map: MapboxMap) => {
	map.removeImage(imagesRenderState.get(image));
	imagesRenderState.delete(image);
};

const removeOldImages = (imagesIds: IdsMap, imagesRenderState: Map<ImageUrl, MapboxImage>, map: MapboxMap) => {
	for (const key of imagesRenderState.keys()) {
		if (!imagesIds[key]) {
			removeImage(key, imagesRenderState, map);
		}
	}
};
